// import { Container } from "@/components/Container";
import React from "react";
import { FC } from "react";
import { UserMfa, TotpSource } from "../User/Mfa";
import styles from "./styles.module.less";

export const BindTotpMFA: FC = () => {
  const MFAToken = new URL(window.location.href).searchParams.get("mfa_token");

  return <UserMfa totpSource={TotpSource.APPLICATION} MFAToken={MFAToken as string} className={styles.configCard} />;
};
